import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-3">
            Poradniki i Artykuły
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Wszystko o <span className="text-primary-500">Kakobuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Oryginalne artykuły i poradniki, które pomogą Ci bezpiecznie i tanio kupować produkty z Chin.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-200 transition-all duration-200 overflow-hidden cursor-pointer"
            >
              {/* Article Image */}
              <div className="w-full h-48 md:h-52 overflow-hidden bg-secondary-100">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>

              {/* Article Content */}
              <div className="flex flex-col flex-1 p-5">
                {/* Meta */}
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>

                {/* Title */}
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>

                {/* Excerpt */}
                <p className="text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {article.excerpt}
                </p>

                {/* Read More */}
                <div className="flex items-center gap-2 mt-4 pt-4 border-t border-background-200/50">
                  <span className="text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors">
                    Czytaj więcej
                  </span>
                  <span className="w-4 h-4 flex items-center justify-center text-accent-500 group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}